import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import { EntryCard } from "./EntryCard";

/**
 * Wraps an EntryCard with @dnd-kit/sortable behavior.
 * The drag handle is a small grip icon overlay; clicking the card body still opens the entry.
 */
export const SortableEntryCard = ({ entry, currentUserId, onClick, disabled = false }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: entry.id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 10 : "auto",
  };

  return (
    <div ref={setNodeRef} style={style} className="relative group" data-testid={`sortable-${entry.id}`}>
      {!disabled && (
        <button
          type="button"
          {...attributes}
          {...listeners}
          aria-label="Eintrag verschieben"
          className="absolute top-3 right-3 z-10 p-1.5 rounded-full bg-white/80 border border-border text-text_secondary hover:text-ink hover:bg-white opacity-0 group-hover:opacity-100 transition-opacity cursor-grab active:cursor-grabbing"
          onClick={(e) => e.stopPropagation()}
          data-testid={`drag-handle-${entry.id}`}
        >
          <GripVertical size={14} strokeWidth={1.7} />
        </button>
      )}
      <EntryCard entry={entry} currentUserId={currentUserId} onClick={onClick} />
    </div>
  );
};

export default SortableEntryCard;
